import { cn } from '@/lib/cn';
import { APP_BRAND_TITLE, APP_VERSION } from '@/lib/appVersion';

type Props = { className?: string };

/** 统一版本展示，便于各壳层复用 */
export function AppVersionLabel({ className }: Props) {
  return (
    <span
      className={cn('inline-block text-[11px] tabular-nums tracking-wide text-slate-400', className)}
      title={`${APP_BRAND_TITLE} · 信息后台`}
    >
      版本 {APP_VERSION}
    </span>
  );
}
